export const getLinks = routes => {
  const links = {};
  for (let k in routes) {
    if (routes.hasOwnProperty(k)) {
      links[k] = routes[k].link;
    }
  }
  return links;
};
